<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit User" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-user-form [user]="user" [isEditing]="true" *ngIf="user"></app-user-form>
        </form>
      </div>
    </section>
  </div>
</div>
